import React from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { useSelector } from "react-redux";

const FrimDetailsTabs = ({
  productDtoList,
  engagementDtoList,
  roleDtoList,
  partnerPayoutDetails,
  ...props
}) => {
  const roleType = useSelector(
    (state) => state?.auth?.checkLogin?.dto?.loggedInRoleType
  );

  const isRMOrCET = roleType === "RM" || roleType === "CET";
  return (
    <div className="inner-Tab-sec-edit-pat">
      <Tab.Container
        id="left-tabs-example"
        className="left-tabs-example"
        defaultActiveKey="first"
      >
        <Row>
          <Col sm={2} className="left-side-tabs branchScroll">
            <Nav variant="pills" className="flex-column left-side-tabs-scroll">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  <div className="tab-selet-test">
                    <h4>
                      Engagement<br></br> with Avanse
                    </h4>
                  </div>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">
                  {" "}
                  <div className="tab-selet-test">
                    <h4>
                      Role <br></br>With Avanse
                    </h4>
                  </div>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="third">
                  {" "}
                  <div className="tab-selet-test">
                    <h4>
                      Product<br></br> Of Avanse
                    </h4>
                  </div>
                </Nav.Link>
              </Nav.Item>
              {isRMOrCET ? (
                <Nav.Item>
                  <Nav.Link eventKey="four">
                    <div className="tab-selet-test">
                      <h4>
                        Partner<br></br> Payout
                      </h4>
                    </div>
                  </Nav.Link>
                </Nav.Item>
              ) : null}
            </Nav>
          </Col>
          <Col sm={10}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Engagement With Avanse</h5>
                        <ul>
                          {engagementDtoList?.length > 0
                            ? engagementDtoList?.map((item) => {
                                return (
                                  <li>
                                    <h2>{item?.partnerTypeName}</h2>
                                  </li>
                                );
                              })
                            : ""}
                        </ul>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                {" "}
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Role With Avanse</h5>

                        <ul>
                          {roleDtoList?.length > 0
                            ? roleDtoList?.map((item) => {
                                return (
                                  <li>
                                    <h2>{item?.partnerFunctionName}</h2>
                                  </li>
                                );
                              })
                            : ""}
                        </ul>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="third">
                {" "}
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Product Of Avanse</h5>

                        <ul>
                          {productDtoList?.length > 0
                            ? productDtoList?.map((item) => {
                                return (
                                  <li>
                                    <h2>{item?.productName}</h2>
                                  </li>
                                );
                              })
                            : ""}
                        </ul>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Tab.Pane>
              {isRMOrCET ? (
                <Tab.Pane eventKey="four">
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="ineer-ed-text tabs-sec"
                    >
                      <Col md={6}>
                        <div className="text-content-ed">
                          <h5>Partner Payout Details</h5>
                          <ul style={{ listStyle: "none", padding: 0 }}>
                            <li style={{ marginBottom: "10px" }}>
                              <strong>First Disbursement:</strong>{" "}
                              {partnerPayoutDetails?.firstDisbursement || "—"}
                            </li>
                            <li style={{ marginBottom: "10px" }}>
                              <strong>Tranche Disbursement:</strong>{" "}
                              {partnerPayoutDetails?.trancheDisbursement || "—"}
                            </li>
                            <li style={{ marginBottom: "10px" }}>
                              <strong>Payout Effective Date:</strong>{" "}
                              {partnerPayoutDetails?.payoutEffectiveDate
                                ? new Date(
                                    partnerPayoutDetails.payoutEffectiveDate
                                  ).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "2-digit",
                                  })
                                : "—"}
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Tab.Pane>
              ) : null}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

export default FrimDetailsTabs;
